<template>
	<div :class="['porlet-content', {'shadow': shadow}, {'collapsed': collapse}]">

		<header>
			<div>
				<ul>
					<li 
					v-for="(porlet,i) in porlets" 
					:key="i"
					@click="current = porlet.titulo"
					:class="{'active': current == porlet.titulo}">
						{{porlet.titulo}}
					</li>
				</ul>
			</div>

			<div>
				<el-button v-if="Object.keys(porlets).find(p => porlets[p].titulo == current && porlets[p].tipo == 'datatable')" class="reload-porlet" size="mini" @click="reload = true" :disabled="reload">
					<i class="el-icon-refresh-right"></i>
				</el-button>

				<el-button class="reload-porlet" size="mini" @click="collapse = !collapse">
					<i :class="[collapse ? 'el-icon-plus' : 'el-icon-minus']"></i>
				</el-button>
			</div>
			
		</header>
		
		<el-container>
			
			<el-container style="background-color: white">
				<el-main style="padding: 0px">
					<template v-for="(elemento, e) in porlets">
						<Porlet
						v-show="current == elemento.titulo && !collapse"
						:key="e"
						:ficha="ficha"
						:id="id"
						:entidad="entidad"
						:porlet="elemento"
						:showHeader="false"
						:shadow="false"
						:marginBottom="false"
						:showFooter="elemento.attr && elemento.attr.hasOwnProperty('showFooter') ? elemento.attr.showFooter : true"
						:forceReload="current == elemento.titulo && reload"
						@afterActions="(val) => $emit('afterActions',val)"
						@reloadEnd="reload = false"
						@setCurrentAction="setCurrentAction"
						@saved="saved"
						@reloadDataTable="reloadDataTable"
						@dblClickSearch="val => $emit('dblClickSearch',val)"/>
					</template>
				</el-main>
			</el-container>

		</el-container>

	</div>
</template>

<script>
	export default {
		name: 'PorletGroup',
		props: {
			porlets: {
				type: [Array, Object],
				required: false,
				default: () => []
			},
			shadow: {
				type: Boolean,
				required: false,
				default: () => true
			},
			ficha: {
				type: Object,
				required: true
			},
			id: String,
			entidad: String
		},
		data () {
			return {
				reload: false,
				collapse: false,
				current: ''
			}
		},
		mounted() {
			this.current = Object.keys(this.porlets)[0]
		},
		methods: {
			setCurrentAction(val) {
				this.$emit('setCurrentAction',val)
			},

			saved(val) {
				this.$emit('saved',val)
			},

			reloadDataTable(table) {
				this.$emit('reloadDataTable', table)
			}
		}
	}
</script>

<style lang="scss">
.porlet-content {
	background-color: transparent;
	border-radius: 4px;
	&.shadow {
		//box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	}
	&.collapsed {
		header {
			border-radius: 4px;
			border: 0px;
		}
	}
	> header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fafafa;
		color: #303133b5;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		padding: 0.4rem 0.5rem 0.7rem 0.5rem;
		text-transform: uppercase;
		font-weight: 500;

		h3 {
			margin: 0;
			font-size: 0.85rem;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			height: 19px;
		}

		.reload-porlet {
			padding: 5px;
			font-size: 0.9rem;
			margin: 0px 5px;
			background-color: #ff000000;
			border: 0px;
			color: #303133;
		}

		ul {
			list-style: none;
			margin: 0px;
			padding: 0px;
			display: flex;
			li {
				font-size: 0.85rem;
				color: #0000004a;
				border-top-left-radius: 4px;
				border-top-right-radius: 4px;
				padding: 0.1rem 0rem;
				text-transform: uppercase;
				font-weight: 600;
				cursor: pointer;
				margin-right: 10px;
				&.active {
					color: #303133b5!important;
				}
			}
		}
	}
}
</style>
